import styled from '@emotion/styled'
import { AdminScope } from '@pubstack/common/src/scope'
import { FunctionComponent, PropsWithChildren, useEffect } from 'react'
import { FieldValues, useForm } from 'react-hook-form'
import { Colors } from '~/assets/style/colors'
import { ElevationLevel } from '~/assets/style/tokens'
import { PageContent } from '~/components/PageContent'
import { Select } from '~/components/Select'
import { SelectOptionProp } from '~/components/SelectableOptionsPopover'
import { TabProp, Tabs } from '~/components/Tabs'
import { WithClassName } from '~/types/utils'

export const ADMIN_SCOPE_DETAIL_HEADER_HEIGHT_PX = 136

const ScopeDetailHeader = styled.div`
  background-color: ${Colors.Ghost};
  display: flex;
  flex-direction: column;
  gap: 20px;
  align-items: flex-start;
  position: sticky;
  top: 0;
  margin-top: -20px;
  padding: 20px 0;
  ${ElevationLevel.low}
`

type PureAdminScopeDetailProps = WithClassName & {
  currentScope?: AdminScope
  onTabClick: (tab: TabProp) => unknown
  onScopeChange: (option: SelectOptionProp) => unknown
  scopes?: AdminScope[]
  tabs: TabProp[]
  breadcrumbs?: React.ReactNode
}
const UnstyledPureAdminScopeDetail: FunctionComponent<PropsWithChildren<PureAdminScopeDetailProps>> = ({ className, breadcrumbs, onTabClick, scopes, currentScope, onScopeChange, tabs, children }) => {
  const selectOptions: SelectOptionProp[] = scopes
    ? scopes.map((s) => ({ value: s.id, label: s.name, trackingLabel: 'common-admin-scopes-detail-scope-set' }))
    : [{ value: '', label: '', trackingLabel: 'common-admin-scopes-detail-scope-set' }]
  const { control, setValue } = useForm<FieldValues>({ defaultValues: { scope: currentScope?.id ?? '' } })

  useEffect(() => {
    setValue('scope', currentScope?.id)
  }, [currentScope])

  return (
    <PageContent className={className} breadcrumbs={breadcrumbs}>
      <ScopeDetailHeader>
        <Select control={control} options={selectOptions} label={'Selected scope'} name={'scope'} onChange={onScopeChange} searchable={true} />
        <Tabs tabs={tabs} onClick={onTabClick} />
      </ScopeDetailHeader>
      {children}
    </PageContent>
  )
}

export const PureAdminScopeDetail = styled(UnstyledPureAdminScopeDetail)``
